/**
 * Frontend audit helper – fires best-effort POST to /api/users/me/audit-action.
 * Never throws. Import and call from any page/component.
 */

const API = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

/**
 * @param {Function} getIdToken  – from useAuth().getIdToken
 * @param {string}   activityType  – DOWNLOAD | VIEW | UPLOAD | LOGIN
 * @param {string}   entityType    – REPORT | KPI | FILE | AUTH
 * @param {string}   entityId      – report name / kpi slug / filename
 * @param {object}   metadata      – extra context
 */
export async function auditLog(getIdToken, activityType, entityType, entityId = '', metadata = {}) {
  try {
    const token = await getIdToken();
    fetch(`${API}/api/users/me/audit-action`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ activity_type: activityType, entity_type: entityType, entity_id: entityId, metadata }),
    });
    // fire-and-forget: intentionally no await
  } catch {
    // never block UI on audit failure
  }
}
